import * as z from "zod";

const datetimeSchema = z.string().refine(
   (val) => {
      // Regex that allows either standard 'T' or a space to separate Date/Time
      const regex = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}(:\d{2})?)$/;
      return regex.test(val);
   },
   { message: "Invalid datetime format" }
);

const deliveryStatuses = ["PLANNED", "IN_TRANSIT", "DELIVERED", "FAILED"] as const;

export const ZDeliveryStatus = z.enum(deliveryStatuses);

export type DeliveryStatus = (typeof deliveryStatuses)[number];

export const ZDelivery = z.object({
   status: ZDeliveryStatus,
   customerNumber: z.string(),
   lastUpdated: datetimeSchema,
   eta: datetimeSchema.nullish(),
   adjustedEta: datetimeSchema.nullish(),
   etaWindowFrom: datetimeSchema.nullish(),
   etaWindowTo: datetimeSchema.nullish(),
   stopNumber: z.number().int().positive().nullish(),
   currentStopNumber: z.number().int().positive().nullish(),
   deliveredTime: datetimeSchema.nullish(),
   orderNumbers: z.array(z.string())
});

const m3OrderStatusCodes = ["0", "20", "22", "33", "44", "66", "69", "77", "79", "90", "99"] as const;

export type M3OrderStatusCode = (typeof m3OrderStatusCodes)[number];

export const ZM3OrderStatus = z.enum(m3OrderStatusCodes);

export type Delivery = z.infer<typeof ZDelivery>;
